<main>
    <section class="faq-section">
      <div class="container">
        <h1 class="main-title">Preguntas Frecuentes</h1>
        <p class="section-description">
          Aquí resolvemos las dudas más comunes sobre nuestros productos, envíos, promociones y mucho más.
        </p>
  
        <div class="accordion-container">
          <div class="faq-item" *ngFor="let faq of faqs" [class.open]="faq.open">
            <div class="faq-question" (click)="toggleFaq(faq)">
              <h3>{{ faq.question }}</h3>
              <span class="toggle-icon">{{ faq.open ? '−' : '+' }}</span>
            </div>
            <div class="faq-answer" [class.visible]="faq.open">
              <p>{{ faq.answer }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>